// import React from "react";

// import Header from "../components/Header";
// import Footer from "../components/Footer";
// import { Outlet } from "react-router-dom";

// function MainLayout() {
//   return (
//     <div >
//       <Header />
//       <main style={{ flex: "1" }}>
//         <Outlet />
//       </main>
//       <Footer />
//     </div>
//   );
// }

// export default MainLayout;
// import React from "react";
// import Header from "../components/Header";
// import Footer from "../components/Footer";
// import { Outlet } from "react-router-dom";
// import EnquiryModal from "../components/EnquiryModal"; // ✅ import the modal
// import { useState } from 'react';

// function MainLayout() {

//    const [formData, setFormData] = useState({
//       name: '',
//       email: '',
//       phone: '',
//       subject: '',
  
//       message: '',
//       inquiryType: '',
//     });
  
//     const [isSubmitting, setIsSubmitting] = useState(false);
  
//     const handleFormChange = (e) => {
//       setFormData({
//         ...formData,
//         [e.target.name]: e.target.value,
//       });
//     };
  
//     const handleSubmit = (e) => {
//       e.preventDefault();
//       setIsSubmitting(true);
  
//       // Simulate form submission
//       setTimeout(() => {
//         alert('Thank you for your message! We\'ll get back to you within 24 hours.');
//         setFormData({
//           name: '',
//           email: '',
//           phone: '',
//           subject: '',
//           message: '',
//           inquiryType: '',
//         });
//         setIsSubmitting(false);
//       }, 2000);
//     };

//   return (
//     <div className="flex flex-col min-h-screen">
//       <Header />
//       <main className="flex-1">
//         <Outlet />
//       </main>
//       <Footer />
//       <EnquiryModal 
//         formData={formData}
//         handleFormChange={handleFormChange}
//         handleSubmit={handleSubmit}
//         isSubmitting={isSubmitting}
      
//       /> {/* ✅ modal added at the root */}
//     </div>
//   );
// }

// export default MainLayout;



// import { useState } from "react";
// import { Outlet } from "react-router-dom";
// import { Toaster, toast } from "react-hot-toast";


// import EnquiryModal from "../components/EnquiryModal"; // ✅ Make sure the path is correct
// import Header from "../components/Header";
//  import Footer from "../components/Footer";

// function MainLayout() {
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     subject: '',
//     message: '',
//     inquiryType: '',
//   });

//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [modalVisible, setModalVisible] = useState(true); // ✅ Controls modal open/close

//   const handleFormChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });
//   };

//  const handleSubmit = async (e) => {
//   e.preventDefault();

//   // Basic validation for required fields
//   const { name, email, phone, subject, message, inquiryType } = formData;

//   if (!name || !email || !phone || !subject || !message || !inquiryType) {
//     toast.error("Please fill in all required fields.");
//     return;
//   }

//   // Optionally validate email format
//   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//   if (!emailRegex.test(email)) {
//     toast.error("Please enter a valid email address.");
//     return;
//   }

//   // Optionally validate phone number (basic check)
// const phoneRegex = /^\d{10}$/;
// if (!phoneRegex.test(phone)) {
//   toast.error("Phone number must be exactly 10 digits (numbers only).");
//   return;
// }


//   setIsSubmitting(true);

//   // Simulate async form submission
//   setTimeout(() => {
//     toast.success("Thank you! We'll contact you soon.");
//     console.log(formData);

//     setFormData({
//       name: '',
//       email: '',
//       phone: '',
//       subject: '',
//       message: '',
//       inquiryType: '',
//     });

//     setIsSubmitting(false);
//     setModalVisible(false);
//   }, 2000);
// };


//   return (
//     <div className="flex flex-col min-h-screen">
//       <Header />
//       <main className="flex-1">
//         <Outlet />
//       </main>
//       <Footer />

//       {/* Global Toast Notification Handler */}
//       <Toaster position="top-center" toastOptions={{ duration: 3000 }} />

//       {/* Enquiry Modal (only if visible) */}
//       {modalVisible && (
//         <EnquiryModal
//           formData={formData}
//           handleFormChange={handleFormChange}
//           handleSubmit={handleSubmit}
//           isSubmitting={isSubmitting}
//           setIsVisible={setModalVisible} // ✅ Pass control to modal
//         />
//       )}
//     </div>
//   );
// }

// export default MainLayout;



// import { useState } from "react";
// import { Outlet } from "react-router-dom";
// import { Toaster, toast } from "react-hot-toast";

// import EnquiryModal from "../components/EnquiryModal";
// import Header from "../components/Header";
// import Footer from "../components/Footer";

// function MainLayout() {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     subject: "",
//     message: "",
//     inquiryType: "",
//   });

//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [modalVisible, setModalVisible] = useState(true);

//   const handleFormChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsSubmitting(true);

//     // Simulate async form submission
//     try {
//       await new Promise((resolve) => setTimeout(resolve, 2000)); // Simulate API call
//       toast.success("Thank you! We'll contact you soon.");
//       setFormData({
//         name: "",
//         email: "",
//         phone: "",
//         subject: "",
//         message: "",
//         inquiryType: "",
//       });
//       setModalVisible(false);
//     } catch (error) {
//       toast.error("Submission failed. Please try again.");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   return (
//     <div className="flex flex-col min-h-screen">
//       <Header />
//       <main className="flex-1">
//         <Outlet />
//       </main>
//       <Footer />

//       <Toaster position="top-center" toastOptions={{ duration: 3000 }} />

//       {modalVisible && (
//         <EnquiryModal
//           formData={formData}
//           handleFormChange={handleFormChange}
//           handleSubmit={handleSubmit}
//           isSubmitting={isSubmitting}
//           setModalVisible={setModalVisible}
//         />
//       )}
//     </div>
//   );
// }

// export default MainLayout;


// import { useState } from "react";
// import { Outlet } from "react-router-dom";
// import { Toaster, toast } from "react-hot-toast";

// import EnquiryModal from "../components/EnquiryModal";
// import Header from "../components/Header";
// import Footer from "../components/Footer";

// function MainLayout() {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     subject: "",
//     message: "",
//     inquiryType: "",
//   });

//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [modalVisible, setModalVisible] = useState(true);

//   const handleFormChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const validateForm = () => {
//     const errors = [];

//     // Name: Required, 2+ characters, letters and spaces only
//     if (!formData.name.trim()) {
//       errors.push("Name is required.");
//     } else if (formData.name.trim().length < 2) {
//       errors.push("Name must be at least 2 characters long.");
//     } else if (!/^[a-zA-Z\s]+$/.test(formData.name.trim())) {
//       errors.push("Name can only contain letters and spaces.");
//     }

//     // Email: Required, valid email format
//     if (!formData.email.trim()) {
//       errors.push("Email is required.");
//     } else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(formData.email.trim())) {
//       errors.push("Please enter a valid email address.");
//     }

//     // Phone: Optional, but if provided, validate format (e.g., 10 digits or international)
//     if (formData.phone.trim() && !/^\+?[\d\s-]{7,15}$/.test(formData.phone.trim())) {
//       errors.push("Please enter a valid phone number (7-15 digits, optional + or -).");
//     }

//     // InquiryType: Required, must be a valid option
//     const validInquiryTypes = ["Admin Enquiry", "General Enquiry", "Support Enquiry", "Other"];
//     if (!formData.inquiryType) {
//       errors.push("Please select an enquiry type.");
//     } else if (!validInquiryTypes.includes(formData.inquiryType)) {
//       errors.push("Invalid enquiry type selected.");
//     }

//     // Message: Required, 10+ characters
//     if (!formData.message.trim()) {
//       errors.push("Message is required.");
//     } else if (formData.message.trim().length < 10) {
//       errors.push("Message must be at least 10 characters long.");
//     }

//     // Subject: Optional, no validation needed beyond trimming
//     return errors;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsSubmitting(true);

//     // Validate form
//     const errors = validateForm();
//     if (errors.length > 0) {
//       // Show each error as a separate toast
//       errors.forEach((error) => toast.error(error));
//       setIsSubmitting(false);
//       return;
//     }

//     // Simulate async form submission
//     try {
//       await new Promise((resolve) => setTimeout(resolve, 2000)); // Simulate API call
//       toast.success("Thank you! We'll contact you soon.");
//       setFormData({
//         name: "",
//         email: "",
//         phone: "",
//         subject: "",
//         message: "",
//         inquiryType: "",
//       });
//       setModalVisible(false);
//     } catch (error) {
//       toast.error("Submission failed. Please try again.");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   return (
//     <div className="flex flex-col min-h-screen">
//       <Header />
//       <main className="flex-1">
//         <Outlet />
//       </main>
//       <Footer />

//       <Toaster position="top-center" toastOptions={{ duration: 3000 }} />

//       {modalVisible && (
//         <EnquiryModal
//           formData={formData}
//           handleFormChange={handleFormChange}
//           handleSubmit={handleSubmit}
//           isSubmitting={isSubmitting}
//           setModalVisible={setModalVisible}
//         />
//       )}
//     </div>
//   );
// }

// export default MainLayout;



import { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Toaster, toast } from "react-hot-toast";

import EnquiryModal from "../components/EnquiryModal";
import Header from "../components/Header";
import Footer from "../components/Footer";
import SuccessPopup from "../components/SuccessPopup";

function MainLayout() {
  const location = useLocation();
  
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
    inquiryType: '',
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  
  // Check if user has visited before using localStorage
  const [modalVisible, setModalVisible] = useState(() => {
    const hasVisited = localStorage.getItem('skillEarthVisited');
    return !hasVisited; // Show modal only if user hasn't visited before
  });

  // Scroll to top on route change and page refresh
  useEffect(() => {
    // Immediate scroll to top for better performance
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // Additional effect to handle page refresh and optimize performance
  useEffect(() => {
    // Scroll to top immediately on component mount (handles page refresh)
    window.scrollTo(0, 0);
    
    // Disable browser's automatic scroll restoration for better control
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    // Preload critical resources
    const preloadLinks = [
      { href: '/src/pages/Home.js', as: 'script' },
      { href: '/src/pages/CoursePage.js', as: 'script' }
    ];

    preloadLinks.forEach(link => {
      const linkElement = document.createElement('link');
      linkElement.rel = 'preload';
      linkElement.href = link.href;
      linkElement.as = link.as;
      document.head.appendChild(linkElement);
    });

    // Cleanup function
    return () => {
      preloadLinks.forEach(link => {
        const existingLink = document.querySelector(`link[href="${link.href}"]`);
        if (existingLink) {
          document.head.removeChild(existingLink);
        }
      });
    };
  }, []);

  const handleFormChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleModalClose = () => {
    setModalVisible(false);
    // Mark that user has visited the site
    localStorage.setItem('skillEarthVisited', 'true');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { name, email, phone, subject, message, inquiryType } = formData;

    // Validate all fields are filled
    if (!name || !email || !phone || !subject || !message || !inquiryType) {
      toast.error("Please fill in all required fields.");
      return;
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address.");
      return;
    }

    // Validate phone number is exactly 10 digits
    const phoneRegex = /^\d{10}$/;
    if (!phoneRegex.test(phone)) {
      toast.error("Phone number must be exactly 10 digits.");
      return;
    }

    setIsSubmitting(true);

    try {
      // Use PHP backend - localhost development
      const API_BASE = window.location.hostname === 'localhost' ? 'http://localhost:8000' : window.location.origin;
      
      console.log('🚀 Sending to PHP API:', `${API_BASE}/php/contact.php`);
      console.log('📡 Request details:', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          message: `Subject: ${formData.subject}\nInquiry Type: ${formData.inquiryType}\nPhone: ${formData.phone}\n\nMessage:\n${formData.message}`
        })
      });
      
      const res = await fetch(`${API_BASE}/php/contact.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          message: `Subject: ${formData.subject}\nInquiry Type: ${formData.inquiryType}\nPhone: ${formData.phone}\n\nMessage:\n${formData.message}`
        }),
      });
      
      console.log('📡 Response status:', res.status);
      console.log('📡 Response headers:', res.headers);
      
      if (!res.ok) {
        const errorText = await res.text();
        console.error('❌ Response error:', errorText);
        throw new Error(`HTTP ${res.status}: ${res.statusText}`);
      }
      
      const contentType = res.headers.get('content-type') || '';
      let data;
      if (contentType.includes('application/json')) {
        data = await res.json();
      } else {
        const text = await res.text();
        console.error('Unexpected non-JSON response:', text.slice(0, 200));
        throw new Error('Unexpected response from server');
      }
      console.log('📨 Response data:', data);
      
      if (data.ok) {
        setFormData({
          name: '',
          email: '',
          phone: '',
          subject: '',
          message: '',
          inquiryType: '',
        });
        setModalVisible(false);
        setShowSuccessPopup(true);
        // Mark that user has visited the site
        localStorage.setItem('skillEarthVisited', 'true');
        console.log('✅ Enquiry submitted successfully');
      } else {
        throw new Error(data.error || 'API request failed');
      }
    } catch (error) {
      console.error('Enquiry send failed:', error);
      toast.error("Sorry, failed to send. Please try again later.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-white dark:bg-slate-900 transition-colors duration-500">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />

      <Toaster position="top-center" toastOptions={{ duration: 3000 }} />

      {modalVisible && (
        <EnquiryModal
          formData={formData}
          handleFormChange={handleFormChange}
          handleSubmit={handleSubmit}
          isSubmitting={isSubmitting}
          setModalVisible={handleModalClose}
        />
      )}

      <SuccessPopup
        isOpen={showSuccessPopup}
        onClose={() => setShowSuccessPopup(false)}
        title="Message Sent Successfully!"
        message="Thank you for contacting Skill Earth Academy! We have received your message and our team will get back to you within 24 hours. We appreciate your interest in our programs!"
      />
    </div>
  );
}

export default MainLayout;
